import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import {filterListingPage_template} from "./filterListingPage_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;


export class pinnedListingPages_template extends vnTemplate {

    public listingPageFilter: filterListingPage_template;
    public showMoreListingPageFilter: filterListingPage_template;
    public tooltip : infoButton_template;
    public parent: any;

    protected getTemplateHtml(): string {

        return `

                <div class="w-pinned listing">
                
                    <div class="pinned-form">
                        <div style="display: flex;align-items: center">     
                            `+ this.listingPageFilter.getHtmlBuild() +`
                            <div class="w-tooltips-adv pos-far-left short" data-bind="visible : isToolTipVisible()">
                             `+ this.tooltip.getHtmlBuild() + `
                            </div>
                        </div>
                        
                        <!-- ko if: listingPages().length > 0 -->
                        <div class="last">
                            <label class="form-label icon i-overwrite">Alternate Title</label>
                            <input type="text" class="input-text" data-bind="value: alternateTitle"/>
                        </div>
                        <div class="border">     
                            `+ this.showMoreListingPageFilter.getHtmlBuild() +`
                        </div>
                        <!-- /ko -->

                        <div class="right">
                            <button class="btn secondary" type="button" data-bind="enable: listingPages().length < maximum(), event:{click: onClickAdd }, text: 'Add to Position ' + (listingPages().length + 1)">Add to List</button>
                        </div>
                      
                    </div>

                    <div class="form-body" data-bind="foreach: listingPages, childrenComplete : handleDragAndDrop($element, listingPages ,'.entry')">
                    
                       <div class="pinned-form listingPage-pinned entry" data-bind="css: {'is-edit' : enableEdit}">
                       
                             <div class="pinned-drag icon i-drag">
                                <span class="pinned-position" data-bind="text: ($index() + 1)"></span>                                   
                             </div>
                             
                             <div class="w-btn" data-bind="visible: !enableEdit">
                                <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEdit }"><span class="hidden-text">Edit</span></button>
                                <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDelete }"><span class="hidden-text">Delete</span></button>
                             </div>
                            
                             <div class="w-title">
                                <div>
                                    <span class="pinned-info">ID :<span data-bind="text: listingPage.id"></span></span>
                                </div>
                                <span class="pinned-title" data-bind="text: listingPage.name + ' (' + listingPage.permalink + ')'"></span>
                             </div>

                             <div class="w-btn" data-bind="visible: enableEdit">
                                <button data-bind="event: { click: $parent.onClickDisableEdit }" class="btn border only-icon icon border i-x-after" type="button"></button>
                             </div>

                             <div class="last">
                                <label class="form-label icon i-overwrite"></label>
                                <span class="pinned-title" data-bind=" visible: !enableEdit, text: alternateTitle"></span>
                                <input type="text" class="input-text"  type="text" data-bind="visible: enableEdit, value: alternateTitle, event:{ focus: $parent.onFocus, blur: $parent.onBlur}"/>
                             </div>
                            
                             <div data-bind="if: showMoreListingPage && !enableEdit" style="margin-bottom: 0;">
                                 <div class="border" style="width: 100%;margin-bottom: 1rem">
                                     <div>
                                        <span class="pinned-title" data-bind="text: showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')'"></span>
                                     </div>
                                 </div>    
                             </div>
                             
                             <div data-bind="visible: enableEdit" style="margin-bottom: 0;">
                                 <div class="border" style="width: 100%;">    
                                     <div>
                                         <div data-bind="template: { name: 'filterListingPage-template', data: $data.showMoreListingPageFilter.getTemplateViewModel() }"></div>
                                     </div>
                                 </div>
                             </div>
                       </div>
                   
                    </div>
                              
                </div>
                
                <div class="" data-bind="visible: listingPages().length == 0">
                     <p class="form-text">There is nothing currently pinned.</p>
                </div>
                `;
    }

    protected getTemplateName(): string {
        return "pinnedListingPages-template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected initPartial() {

        this.listingPageFilter = new filterListingPage_template(`${this.idElement}_filterListingPage`, this.getTemplateViewModel(), this.caller);
        this.listingPageFilter.setPlaceholder("Main Hub Page");
        this.listingPageFilter.setShowDetails(true);
        this.listingPageFilter.setIsLoadingAnimationEnable(true);

        this.showMoreListingPageFilter = new filterListingPage_template(`${this.idElement}_filterShowMoreListingPage`, this.getTemplateViewModel(), this.caller);
        this.showMoreListingPageFilter.setPlaceholder('Show More Hub Page');
        this.showMoreListingPageFilter.setShowDetails(true);
        this.showMoreListingPageFilter.setIsLoadingAnimationEnable(true);

        this.tooltip = new infoButton_template('tooltip', this.getTemplateViewModel(), this.caller);
        this.tooltip.setTitle('Pinned Hub Page');
    }

    setParent(parent): void {
        this.parent = parent;
    }


    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
             maximum: ko.observable(25)
            ,isToolTipVisible: ko.observable(false)
            ,listingPages: ko.observableArray([])
            ,alternateTitle: ko.observable('')
            ,onClickAdd: function (data, event) {
                huit_neuf_this.onClickAdd();
            }
            ,onClickEdit: function (data, event) {
                huit_neuf_this.onClickEdit(data);
            }
            ,onClickDelete: function (data, event) {
                huit_neuf_this.onClickDelete(data);
            }
            ,handleDragAndDrop: function(element, currentObservableArray ,childrenSelector){
                huit_neuf_this.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
            }
            ,onFocus: function(data, event){
                huit_neuf_this.onFocus(data, event);
            }
            ,onBlur: function(data, event){
                huit_neuf_this.onBlur(data, event);
            },
            onClickDisableEdit : function(data, event){
                huit_neuf_this.onClickDisableEdit(data);
            }
        };
    }


    public setMaximum(maximum){

        this.getTemplateViewModel().maximum(maximum)
    }

    public setIsToolTipVisible(bool){

        this.getTemplateViewModel().isToolTipVisible(bool)
    }

    public setListingPages(listingPages: Array<any>): void {

        this.getTemplateViewModel().listingPages(listingPages);
    }

    public getListingPages(){

        this.updatePosition();
        return this.getTemplateViewModel().listingPages();
    }

    public updatePosition(){

        let listingPages = this.getTemplateViewModel().listingPages();

        for (let i = 0; i < listingPages.length; i++) {

            listingPages[i].position =  i + 1;
        }

        this.getTemplateViewModel().listingPages([]);
        this.getTemplateViewModel().listingPages(listingPages);
    }

    public onClickAdd(){

        if(!this.listingPageFilter.getTemplateViewModel().idListingPage()) {
            this.caller.triggerNotification('Main hub page is required!!');
            return;
        }

        if(this.getTemplateViewModel().listingPages().length == this.getTemplateViewModel().maximum()) {
            this.caller.triggerNotification('Maximum number reached. Please delete one to add new! ');
            return;
        }

        let listingPages = this.getTemplateViewModel().listingPages();
        let mainListingPage = this.listingPageFilter.getTemplateViewModel().listingPageObj();
        let showMoreListingPage = this.showMoreListingPageFilter.getTemplateViewModel().listingPageObj();
        let alternateTitle = this.getTemplateViewModel().alternateTitle();

        let index = this.getListingPageIndex(mainListingPage);
        if(index < 0) {


            let totalListingPages = (this.parent) ? this.parent.getTotalPinnedHubPages() :  listingPages.length;

            let uuid = `${this.idElement}_filterShowMoreListingPage${totalListingPages}`;
            let filter: filterListingPage_template = new filterListingPage_template(uuid, this.getTemplateViewModel(), this.caller);
            filter.setPlaceholder('Show More Listing Page');
            filter.setShowDetails(true);
            filter.setIsLoadingAnimationEnable(true);

            let newPinnedListingPage = {
                uuid:                       uuid,
                id:                         null,
                idListingPage:              mainListingPage.id,
                listingPage:                mainListingPage,
                idShowMoreListingPage:      null,
                showMoreListingPage:        showMoreListingPage,
                showMoreListingPageFilter:  filter,
                position:                   listingPages.length + 1,
                dateCreated:                null,
                alternateTitle:             alternateTitle,
                enableEdit:                 false
            };

            //set value and filter too for vie/edit mode
            if (showMoreListingPage) {

                newPinnedListingPage.idShowMoreListingPage = showMoreListingPage.id;
                newPinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().idListingPage(showMoreListingPage.id);
                newPinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPageObj(showMoreListingPage);
                newPinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPage(showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')');
            }

            listingPages.push(newPinnedListingPage);
            this.getTemplateViewModel().listingPages([]);
            this.getTemplateViewModel().listingPages(listingPages);
            this.clearInput();

        } else {

            this.caller.triggerNotification('Main Hub page already pinned');
        }
    }

    public onClickEdit(data){

        let listingPages = this.getTemplateViewModel().listingPages();
        let index = this.getListingPageIndex(data.listingPage);
        if(index > -1){
            listingPages[index].enableEdit = true;
        }
        this.getTemplateViewModel().listingPages([])
        this.getTemplateViewModel().listingPages(listingPages);
    }

    public onClickDelete(data){

        let listingPages = this.getTemplateViewModel().listingPages();
        let index = this.getListingPageIndex(data.listingPage);
        if(index > -1){
            listingPages.splice(index, 1)
        }
        this.getTemplateViewModel().listingPages([])
        this.getTemplateViewModel().listingPages(listingPages);
    }

    public getListingPageIndex(data){

        let listingPages = this.getTemplateViewModel().listingPages();

        return listingPages.findIndex(listingPage => listingPage.idListingPage == data.id);
    }

    public clearInput(){

        this.listingPageFilter.clearInput();
        this.showMoreListingPageFilter.clearInput();
        this.getTemplateViewModel().alternateTitle('');
    }

    public filterSimpleOnAutoComplete(results, idElement){

        let listingPages = this.getTemplateViewModel().listingPages();
        let index = listingPages.findIndex(listingPage => listingPage.showMoreListingPageFilter.idElement == idElement);
        if(index > -1){
            listingPages[index].showMoreListingPageFilter.setOptions(results);
        }
    }

    public handleDragAndDrop(element, currentObservableArray ,childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
    }

    public onFocus(data, event){

        let parent = event.currentTarget.parentNode.parentNode;
        if(parent.hasAttribute('draggable')){
            parent.setAttribute('draggable', 'false')
        }
    }

    public onBlur(data, event){

        let parent = event.currentTarget.parentNode.parentNode;
        if(parent.hasAttribute('draggable')){
            parent.setAttribute('draggable', 'true')
        }
    }

    public onClickDisableEdit(data){
        let listingPages = this.getTemplateViewModel().listingPages();
        let index = this.getListingPageIndex(data.listingPage);
        if(index > -1){
            listingPages[index].enableEdit = false;
        }
        this.getTemplateViewModel().listingPages([])
        this.getTemplateViewModel().listingPages(listingPages);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/pinnedListingPages_template.ts